export default function getStructuredData(description, homepageUrl, localeLinkedData, simpleLocale) {
  const localeMap = {
    bg: 'Bulgarian',
    ceb: 'Cebuano',
    cs: 'Czech',
    da: 'Danish',
    de: 'German',
    el: 'Greek',
    en: 'English',
    es: 'Spanish',
    et: 'Estonian',
    fi: 'Finnish',
    fj: 'Fijian',
    fr: 'French',
    hr: 'Croatian',
    hu: 'Hungarian',
    id: 'Indonesian',
    it: 'Italian',
    ja: 'Japanese',
    ko: 'Korean',
    km: 'Cambodian',
    lt: 'Lithuanuan',
    lv: 'Latvian',
    mg: 'Malagasy',
    mn: 'Mongolian',
    ms: 'Malay',
    nl: 'Dutch',
    no: 'Norwegian',
    pl: 'Polish',
    pt: 'Portuguese',
    ro: 'Romanian',
    ru: 'Russian',
    sk: 'Slovak',
    sm: 'Samoan',
    sq: 'Albanian',
    sr: 'Serbian',
    sv: 'Swedish',
    th: 'Thai',
    tl: 'Tagalog',
    to: 'Tongan',
    uk: 'Ukrainian',
    vi: 'Vietnamese',
    'zh-hans': 'Chinese Simplified',
    zh: 'Chinese Traditional',
  }
  const languageName = localeMap[simpleLocale] ? localeMap[simpleLocale] : simpleLocale
  return {
    '@context': 'http://schema.org',
    '@type': 'Organization',
    name: 'FamilySearch',
    legalName: 'FamilySearch International',
    parentOrganization: localeLinkedData?.publisher?.parentOrganization?.name,
    description,
    url: homepageUrl,
    sameAs: localeLinkedData.sameAs,
    logo:
      'https://edge.fscdn.org/assets/components/hf/assets/img/logos/tree-logotype-2x-57dfa10aa24b73764cf6d7f606695d3a.png',
    subOrganization: {
      '@type': 'Organization',
      name: 'FamilySearch Support',
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '+1 (866) 406-1830',
        email: 'support@familysearch.org',
      },
    },
    founder: [
      {
        '@type': 'Person',
        name: 'James H. Anderson',
        url: `https://ancestors.familysearch.org/${simpleLocale}/KWJQ-GDV/james-henry-anderson-1857-1934`,
      },
      {
        '@type': 'Person',
        name: 'Abraham H. Cannon',
        url: `https://ancestors.familysearch.org/${simpleLocale}/KWCK-27Q/abraham-hoagland-cannon-1859-1896`,
      },
      {
        '@type': 'Person',
        name: 'George Q. Cannon',
        url: `https://ancestors.familysearch.org/${simpleLocale}/KWC8-VG3/george-quayle-cannon-1827-1901`,
      },
      {
        '@type': 'Person',
        name: 'John Jaques',
        url: `https://ancestors.familysearch.org/${simpleLocale}/KWJX-3V1/john-jaques-1827-1900`,
      },
      {
        '@type': 'Person',
        name: 'Duncan McAllister',
        url: `https://ancestors.familysearch.org/${simpleLocale}/K2MC-48D/duncan-mcneil-mcallister-1842-1931`,
      },
      {
        '@type': 'Person',
        name: 'Amos Milton Musser',
        url: `https://ancestors.familysearch.org/${simpleLocale}/KW8X-P5W/amos-milton-musser-sr-1830-1909`,
      },
      {
        '@type': 'Person',
        name: 'John Nicholson',
        url: `https://ancestors.familysearch.org/${simpleLocale}/KW6D-CT4/john-nicholson-1839-1909`,
      },
      {
        '@type': 'Person',
        name: 'George Reynolds',
        url: `https://ancestors.familysearch.org/${simpleLocale}/KWCJ-ZM6/george-reynolds-1842-1909`,
      },
      {
        '@type': 'Person',
        name: 'Franklin D. Richards',
        url: `https://ancestors.familysearch.org/${simpleLocale}/KWNN-566/franklin-dewey-richards-1821-1899`,
      },
      {
        '@type': 'Person',
        name: 'Joseph F. Smith',
        url: `https://ancestors.familysearch.org/${simpleLocale}/KWCW-8ZJ/joseph-fielding-smith-1838-1918`,
      },
      {
        '@type': 'Person',
        name: 'Lorenzo Snow',
        url: `https://ancestors.familysearch.org/${simpleLocale}/KW84-5CT/lorenzo-snow-1814-1901`,
      },
      {
        '@type': 'Person',
        name: 'James B. Walkley',
        url: `https://ancestors.familysearch.org/${simpleLocale}/KWJK-44L/james-benjamin-walkley-1863-1941`,
      },
      {
        '@type': 'Person',
        name: 'Wilford Woodruff',
        url: `https://ancestors.familysearch.org/${simpleLocale}/KWNT-8NB/wilford-woodruff-1807-1898`,
      },
    ],
    publisher: {
      '@type': 'Organization',
      name: 'FamilySearch',
    },
    potentialAction: {
      '@type': 'SearchAction',
      target: `https://www.familysearch.org/${simpleLocale}/search?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
    breadcrumb: {
      '@type': 'BreadcrumbList',
      description: 'Breadcrumbs List',
      itemListElement: {
        '@type': 'ListItem',
        position: 1,
        name: `${languageName} Homepage`,
        item: `https://www.familysearch.org/${simpleLocale}/`,
      },
    },
  }
}
